import useI18n from '@/src/hooks/use_i18n'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Image from 'src/components/CustomImage'

export default function SuccessModal({ show, handleClose }: { show: boolean; handleClose: () => void }) {
  const { $t } = useI18n()
  return (
    <div>
      <Modal show={show} onHide={handleClose} centered>
        <div className="px-16 py-8">
          <p>{$t('ResConsolePIndex.global.__successTips')}</p>
          <Image src="/assets/images/api/registerSuccess.png" width={598} height={270} alt="register success" />
          <Button variant="primary" onClick={handleClose} className="w-100 mt-4">
            {$t('ResConsolePIndex.global.__ok')}
          </Button>
        </div>
      </Modal>
    </div>
  )
}
